import _sfc_main from "./component-library186.mjs";
import "./component-library187.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "cart-sticky" }, [_c("div", { staticClass: "cart-sticky__prices" }, [_setup.price ? _c(_setup.Prices, { attrs: { "is-price": _setup.price, "was-price": _setup.wasPrice, "theme": "light", "post-text-is-price": _setup.priceMonthly && !_setup.wasPrice ? "einmalig" : "", "post-text-was-price": _setup.priceMonthly && _setup.wasPrice ? "einmalig" : "" } }) : _vm._e(), _setup.priceMonthly ? _c(_setup.Prices, { attrs: { "is-price": _setup.priceMonthly, "was-price": _setup.wasPriceMonthly, "theme": "light", "post-text-is-price": _setup.wasPriceMonthly ? "" : "monatlich", "post-text-was-price": _setup.wasPriceMonthly ? "monatlich" : "" } }) : _vm._e()], 1), _c("div", { staticClass: "cart-sticky__add-to-cart" }, [_vm._t("addToCart", function() {
    return [_c(_setup.AddToCartButton, { attrs: { "display-icon": "", "display-text": false, "theme": "light" }, on: { "add-to-cart": (args) => _vm.$emit("add-to-cart", args) } })];
  }), _vm._t("addToCartContent")], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "482c3dd0",
  null,
  null
);
const cartSticky = __component__.exports;
export {
  cartSticky as default
};
